/* eslint-disable @next/next/no-img-element */
import { ContentDataBlockLink } from './Content';

interface LinkProps {
  block: ContentDataBlockLink;
}

export default function Link({ block }: LinkProps) {
  return (
    <a href={block.data.link} target='_blank' className='Content__link' rel='noreferrer'>
      {block.data.meta.image && (
        <div className='Content__linkImage'>
          <img src={block.data.meta.image.url} alt={block.data.meta.title ?? ''} />
        </div>
      )}
      <div className='Content__linkContent'>
        {block.data.meta.title && (
          <div
            className='Content__linkContentTitle'
            dangerouslySetInnerHTML={{ __html: block.data.meta.title }}
          />
        )}
        {block.data.meta.description && (
          <div
            className='Content__linkContentDescription'
            dangerouslySetInnerHTML={{ __html: block.data.meta.description }}
          />
        )}
      </div>
    </a>
  );
}
